module.exports = __webpack_public_path__ + "img/cool-background.900c1dd1.svg";